module.exports = `${require.publicPath}sby-logo.0b2e108d.png`;